import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

require('./bootstrap.min.css');
require('./app.css');

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js